// extracted by mini-css-extract-plugin
export default {"input":"MultipleAttachments_input__Pc9jo","list":"MultipleAttachments_list__Ltoqf"};